// 페이지별 title/description/canonical/OG 메타와 JSON-LD를 한 곳에서 주입하는 Helmet 래퍼
import { Helmet } from 'react-helmet-async';

export const SITE_URL = 'https://mrdevello.com';
const SITE_NAME = '미스터디벨로';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.webp`;

type SeoProps = {
	title: string; // 페이지 제목 (사이트명은 자동으로 붙음)
	description: string;
	path: string; // '/faq' 처럼 슬래시로 시작하는 경로
	image?: string;
	jsonLd?: Record<string, unknown>;
};

const toAbsolute = (url: string) =>
	url.startsWith('http') ? url : `${SITE_URL}${url}`;

const Seo = ({ title, description, path, image, jsonLd }: SeoProps) => {
	const fullTitle = `${SITE_NAME} - ${title}`;
	const url = `${SITE_URL}${path}`;
	const ogImage = image ? toAbsolute(image) : DEFAULT_IMAGE;

	return (
		<Helmet>
			<title>{fullTitle}</title>
			<meta name="description" content={description} />
			<link rel="canonical" href={url} />
			<meta property="og:title" content={fullTitle} />
			<meta property="og:description" content={description} />
			<meta property="og:url" content={url} />
			<meta property="og:image" content={ogImage} />
			<meta name="twitter:title" content={fullTitle} />
			<meta name="twitter:description" content={description} />
			<meta name="twitter:image" content={ogImage} />
			<meta name="apple-mobile-web-app-title" content={fullTitle} />
			{jsonLd && (
				<script type="application/ld+json">
					{JSON.stringify(jsonLd)}
				</script>
			)}
		</Helmet>
	);
};

export default Seo;
